import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Modal } from 'antd';
import { AppState } from '../../../../reducers';
import { setShowModal, setReadingMode, clearOrder } from '../../PurchaseOrderActions';
import PurchaseOrderCreateContent from '../PurchaseOrderCreateContent/PurchaseOrderCreateContent';
import { useCallback } from 'react';

function ModalComponent({ show_modal, title, loading, is_mobile, setShowModal, setReadingMode }: any) {
  const handleOk = useCallback(() => {
    setShowModal(false);
    setReadingMode(false);
  }, [setReadingMode, setShowModal]);

  const handleCancel = useCallback(() => {
    setShowModal(false);
    setReadingMode(false);
    clearOrder();
  }, [setReadingMode, setShowModal]);

  return (
    <Modal
      mask={true}
      maskClosable={false}
      title={title}
      width={is_mobile ? '100%' : '90%'}
      open={show_modal && !loading}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <PurchaseOrderCreateContent />
    </Modal>
  );
}

const mapStateToProps = (state: AppState) => ({
  show_modal: state.purchase_order.show_modal,
  loading: state.purchase_order.loading,
  is_mobile: state.auth.is_mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      setShowModal,
      setReadingMode,
      clearOrder,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModalComponent);
